var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"loading flex_g vertical flex_center flex_column"},[_c('img',{attrs:{"src":require("@/assets/images/load.gif")}}),_c('p',[_vm._v("加载中.....")])])
}
var staticRenderFns = []

export { render, staticRenderFns }